import { useParams } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { EditObjectStepScreen } from 'widgets/kyrgyzstan/edit-object-editor'

import {
  CreateObjectStepId,
  editObjectSessionStore,
} from 'entities/kyrgyzstan/model'

const KyrgyzstanEditObjectStepPage = observer(() => {
  const { objectId, stepId } = useParams<{
    objectId: string
    stepId: string
  }>() as {
    objectId: string
    stepId: string
  }
  const parentPath = RoutingPaths.kyrgyzstan.objects.edit.path(objectId)

  return (
    <EditObjectStepScreen
      draftId={editObjectSessionStore.draftId}
      parentPath={parentPath}
      stepId={stepId}
      getStepPath={(nextStepId: CreateObjectStepId) =>
        RoutingPaths.kyrgyzstan.objects.edit.step.path(objectId, nextStepId)
      }
    />
  )
})

export default KyrgyzstanEditObjectStepPage
